import { render, staticRenderFns } from "./profile-links.vue?vue&type=template&id=4171873c&scoped=true&"
import script from "./profile-links.vue?vue&type=script&lang=js&"
export * from "./profile-links.vue?vue&type=script&lang=js&"
import style0 from "./profile-links.vue?vue&type=style&index=0&id=4171873c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171873c",
  null
  
)

export default component.exports